import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import Lquote from './../../public/img/l_quote.png';
import Rquote from './../../public/img/r_quote.png';

import anuradha from './../../public/img/testimonial/anuradha.png';
import bindu from './../../public/img/testimonial/bindu.png';
import mekhala_balaji from './../../public/img/testimonial/mekhala_balaji.png';

const items = [
  {
    id: 1,
    src:bindu,
    caption: "Bindu Subramaniam",
    occupation: "Parent of Mahati - Class II, NPS",
    header: `My daughter Mahati started using HeyMath! when she was three, and 
    she loved it so much she started giving tutorials to everyone she met! It's 
    so much fun that she never realized she was doing hard work and learning so much. 
    I think HeyMath! is an incredible resource for children to learn math, 
    and I can't recommend it enough.`
  },
  {
    id: 2,
    src:mekhala_balaji,
    caption: "Mekhala",
    occupation: "Grade 7, Bala Vidya Mandir, Chennai",
    header: `I like PLP because it's easy to use. It helps correct my
     mistakes by giving me recommended practice sums & sometimes videos too.`
  },
  {
    id: 3,
    src:anuradha,
    caption: "Anuradha",
    occupation: "Parent of Arjun - Grade 3, AAIS, ECR",
    header: `My 8 year old loves Math and HeyMath! is a big reason behind that! 
    The lessons are cool and I find that the content is structured intuitively, 
    keeping the learner in mind. As a parent I'm impressed with Prasso that challenges 
    kids to master the topic yet there's no associated pressure 
    - such a welcome change from traditional methods! Highly 
    recommend this program to parents and teachers across curriculum!`
  }
];

class OurParents extends PreLoginSessionCheck {
  constructor(props) {
    super(props);
  }

    render() {
      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight:true,
        autoplay:true,
        autoplaySpeed:3000,
        pauseOnHover:true
      };

      return (
       <div id="OurparFBSlider">
<div className="container justify-content-md-center">


          <Slider {...settings}>
          {(() => {
											return(
                        items.map((fbcomm, index) =>
                      <div className="fbcont" key={index}>
											
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 txtcont">

                      <div className="txtpart">
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 test-pic">
                             <figure class="figure">
                              <img src={items[index].src} class="figure-img img-fluid rounded" alt={items[index].caption}></img>
                              <figcaption class="figure-caption"><div className="txtcaption">
                                {items[index].caption}
                                </div>

                                <div className="txtoccupation">
                                {items[index].occupation}
                                </div></figcaption>
                            </figure>
                        </div>

                        <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8 test-cont">
                        <div className="txtimg">   
                        <img src={Lquote} />
                        </div>

                            <div className="txtheader">
                            {items[index].header}
                            </div>
                          </div>

                      </div>


														</div>
                             </div>
													)
											);											

									})()}			

      </Slider>

          </div>
       </div>

      );
    }
  }




export default OurParents;



// WEBPACK FOOTER //
// ./src/prelogin/src/components/OurParents.js